import React, { useContext } from "react";
import { DataContext } from "../context/DataContext";
import { useHistory } from "react-router-dom";
import { toTitleCase } from "../util/titleCase";

const PaymentCard = ({ arrayDataSets }) => {
  console.log(arrayDataSets, "arrayDataSetsarrayDataSetsarrayDataSets");
  const dataContext = useContext(DataContext);
  const history = useHistory();

  const sendClicked = (subject) => {
    // console.log(subject, "subjectsubjectsubjectsubject");
    localStorage.setItem("clickedHomework", JSON.stringify(subject));
    dataContext.setHomework(subject);
    history.push("/viewHomework");
  };


  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 col-gap-6 px-4 mb-16">
        {arrayDataSets && arrayDataSets.length === 0 ? (
          <div className="text-red-100 text-sm">
            {" "}
            Oops! No homework in this category{" "}
          </div>
        ) : (
          arrayDataSets.map((item, index) => (
            <div
              className="bg-white p-4 mb-6 text-gray-100 mr-4 newNotesShadow"
              key={index}
            >
              <div className="flex justify-between items-center mb-4">
                <span className="text-gray-300 text-xs leading-4">
                  {" "}
                  {/* {item.class}{" "} */}
                </span>
                {/* <span className="w-3 h-3 bg-green-100 rounded-full" /> */}
              </div>
              <div className="  ">
                <div className="flex text-center justify-center font-semibold  text-base ">
                  {toTitleCase(item.firstname)} {item.surname}
                </div>
                <div className="flex text-center justify-center mx-auto font-medium text-sm mb-4">
                  {toTitleCase(item.term)} <br /> {item.year}
                </div>
                {/* <div className="flex text-center justify-center font-semibold  text-base ">
                 code: {item.pickupCode}
                </div> */}
                <div className="bg-blue-900 block mx-auto">
                  {/* <div className="bg-blue-900 block mx-auto newHomeworkView"> */}
                  {/* <div className="bg-blue-900  "> */}
                  <a
                    // href= 'https://basic.edves.net/PayDirectPage1.php'
                    href={`${item.paymentLink}`}
                   
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex justify-center text-blue-100 text-xs font-semibold leading-3 p-2 cursor-pointer"
                  >
                     Make Payment
                  </a>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </>
  );
};

export default PaymentCard;
